<template>
    <div>
        <transition name="fade" mode="out-in">
            <div key="1" v-if="paso === 1" id="paso-1">
                <BuscarAbonadoComponent
                    :mode="mode"
                    :amigo_abonado="true"
                    @abonadoEncontrado="amigoAbonadoEncontrado"
                />
                <SeleccionarZonaComponent
                    v-if="evento && abonado_encontrado"
                    class="col-12"
                    :evento="evento"
                    :mode="mode"
                    :sesion_id="sesion.id"
                    @getZonasFormateadas="getZonasFormateadas"
                    @goTo="finalizarPasoUno"
                />
            </div>
            <div key="2" v-if="paso >= 2" class="mt-3" id="paso-2">
                <PasoDosComponent
                    :evento="evento"
                    :zona="zona_seleccionada"
                    :zonas_formateadas="zonas_formateadas"
                    :recinto="recinto"
                    :entradas="entradas"
                    :dia_abonado="false"
                    :datos_compradores="datos_compradores"
                    :puede_cambiar="true"
                    :place="evento.place_obj"
                    :mode="mode"
                    @resetDatos="resetDatos"
                    @goTo="finalizarPasoDos"
                    @actualizarEntradas="resetPaso3"
                />
            </div>
        </transition>
        <VisibilidadReducida :zona="zona_seleccionada" @aceptar="AceptarVisibilidadReducida"/>
        <transition name="fade" mode="out-in">
            <div key="3" v-if="paso >= 3" class="mt-3" id="paso-3">
                <PasoTresComponent
                    :evento="evento"
                    :event_id="evento.id"
                    :sesion_id="sesion.id"
                    :carrito_id="carrito_id"
                    :datos_compradores="datos_compradores"
                    :entradas_seleccionadas="entradas"
                    :solicitar_datos="evento.solicitar_datos"
                    @goTo="finalizarPasoTres"
                />
            </div>
        </transition>
        <transition name="fade" mode="out-in">
            <div key="4" v-if="paso >= 4" class="mt-3" id="paso-4">
                <PasoCuatroComponent
                    :mode="mode"
                    :amigo_abonado_id="amigo_abonado_id"
                    :recinto="recinto"
                    :datos_compra="datos_compra"
                    :email="email"
                    :carrito_id="carrito_id"
                    :whatsapp="whatsapp"
                    :evento="evento"
                    @goTo="goTo" />
            </div>
        </transition>
    </div>
</template>

<script>

    import BuscarAbonadoComponent from '@/components/backend/stepper/components/BuscarAbonadoComponent';
    import SeleccionarZonaComponent from '@/components/backend/stepper/components/SeleccionarZonaComponent';
    import PasoDosComponent from '@/components/backend/stepper/eventos/PasoDosComponent.vue';
    import PasoTresComponent from '@/components/backend/stepper/eventos/PasoTresComponent.vue';
    import PasoCuatroComponent from '@/components/backend/stepper/eventos/PasoCuatroComponent.vue';
    import VisibilidadReducida from '@/components/backend/stepper/eventos/Modal/VisibilidadReducida.vue'


    export default {
        props: ['evento', 'sesion', 'recinto', 'entradas', 'paso', 'mode'],
        data() {
            return {
                datos_compradores: [],
                zona_seleccionada: null,
                datos_compra: null,
                puede_cambiar: false,
                asientos: [],
                mostrar_opciones: false,
                abonado_encontrado: false,
                asiento_disponible: false,
                carrito_id: null,
                amigo_abonado_id: null,
                zonas_formateadas: null,
            }
        },
        created() {
            if (!this.evento.tiene_recinto) {
                this.finalizarPasoDos(2, null);
            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            }
        },
        methods: {
            resetDatos(new_zona) {
                this.datos_compradores = [];
                this.zona_seleccionada = new_zona;
            },
            getZonasFormateadas(zonas_formateadas){
                this.zonas_formateadas = zonas_formateadas;
            },
            amigoAbonadoEncontrado(data) {
                if (data) {
                    this.asientos = [];
                    this.amigo_abonado_id = data.id;
                    this.abonado_encontrado = true;
                    this.goTo(1);
                } else {
                    this.abonado_encontrado = false;
                }
            },
            finalizarPasoUno(paso, zona) {
                if(paso >= 2) {
                    this.zona_seleccionada = zona;
                }

                if(zona.visibilidad_reducida){
                    this.$modal.show('visibilidad-reducida');
                }

                this.$emit('cambiarPaso', paso)

                this.$nextTick(function() {
                    this.scrollTo('#paso-' + paso);
                });
            },
            finalizarPasoDos(paso, datos, carrito_id) {
                if (carrito_id) {
                    this.carrito_id = carrito_id;
                }

                if (datos) {
                    this.datos_compradores = datos;
                }

                if (Array.isArray(this.entradas) && this.entradas.length > 0) {
                    for (let i = 0; i < this.entradas.length; i++) {
                        if (this.entradas[i].unidades > 0) {
                            for (let x = 0; x < this.entradas[i].unidades; x++) {
                                this.datos_compradores.push({
                                    apellidos: '',
                                    asiento: {
                                        zona_nombre: 'General'
                                    },
                                    descuento: 0,
                                    dni: '',
                                    es_nuevo: true,
                                    nombre: '',
                                    precio: {
                                        descripcion: this.entradas[i].name,
                                        gd: this.entradas[i].price_management,
                                        gd_interno: this.entradas[i].price_management_interno,
                                        price_management_taquilla: this.entradas[i].price_management,
                                        id: this.entradas[i].id,
                                        precio: this.entradas[i].price,
                                        precio_total: this.entradas[i].total_price
                                    },
                                    precios: [
                                        {
                                            descripcion: this.entradas[i].name,
                                            gd: this.entradas[i].price_management,
                                            gd_interno: this.entradas[i].price_management_interno,
                                            id: this.entradas[i].id,
                                            precio: this.entradas[i].price,
                                            price_management_taquilla: this.entradas[i].price_management,
                                            precio_total: this.entradas[i].total_price
                                        }
                                    ],
                                    telefono: '',
                                    url_imprimir: null
                                });
                            }
                        }
                    }
                }

                this.$emit('cambiarPaso', paso)

                this.$nextTick(function() {
                    this.scrollTo('#paso-' + paso);
                });
            },
            finalizarPasoTres(paso, datos, email, whatsapp) {
                this.email = email;
                this.whatsapp = whatsapp;
                let datos_compra = null
                if (this.zona_seleccionada != null) {
                    datos_compra = {
                        evento_id: this.evento.id,
                        sesion_id: this.sesion.id,
                        zona_id: this.zona_seleccionada.id,
                        datos_compradores: this.datos_compradores,
                        metodo_pago: datos.metodo_pago,
                        modalidad: 0,
                        tipo: false,
                        concepto: datos.concepto,
                        enviar_email: datos.enviar_email,
                        email: datos.email,
                        nombre: datos.nombre,
                        telefono: datos.telefono,
                        enviar_whatsapp: datos.enviar_whatsapp,
                        cp: datos.cp,
                        recinto: true,
                        nombre_comprador: datos.nombre_comprador,
                        apellidos_comprador: datos.apellidos_comprador,
                        dni_comprador: datos.dni_comprador,
                        telefono_comprador: datos.telefono_comprador
                    };
                } else {
                    datos_compra = {
                        evento_id: this.evento.id,
                        sesion_id: this.sesion.id,
                        zona_id: 1,
                        datos_compradores: this.datos_compradores,
                        entradas: this.entradas,
                        metodo_pago: datos.metodo_pago,
                        modalidad: 0,
                        tipo: false,
                        concepto: datos.concepto,
                        enviar_email: datos.enviar_email,
                        email: datos.email,
                        nombre: datos.nombre,
                        telefono: datos.telefono,
                        enviar_whatsapp: datos.enviar_whatsapp,
                        cp: datos.cp,
                        recinto: false,
                        nombre_comprador: datos.nombre_comprador,
                        apellidos_comprador: datos.apellidos_comprador,
                        dni_comprador: datos.dni_comprador,
                        telefono_comprador: datos.telefono_comprador
                    };
                }
                if (datos) {
                    this.datos_compra = datos_compra;
                }
                this.$emit('cambiarPaso', paso)

                this.$nextTick(function() {
                    this.scrollTo('#paso-' + paso);
                });
            },
            scrollTo(paso) {
                this.$scrollTo(paso, 100)
            },
            resetPaso3() {
                if (this.paso >= 3) {
                    this.paso = 2;
                    this.$nextTick(function() {
                        this.$emit('cambiarPaso', 3)
                    });
                }
            },
            goTo(paso) {
                if (paso < this.paso) {
                    if (paso === 1) {
                        this.datos_compra = [];
                        this.datos_compra.metodo_pago = [];
                        this.zona_seleccionada = [];
                        this.datos_compradores = [];
                        this.abonado_encontrado = false;
                        this.$emit('resetearEntradas', true);
                    } else if (paso === 2) {
                        this.datos_compra = null;
                        this.datos_compradores = [];
                        if (!this.evento.tiene_recinto) {
                            this.getEvento();
                        }
                        this.abonado_encontrado = false;
                        this.$emit('resetearEntradas', true);
                        this.$emit('cambiarPaso', 1)

                    } else {
                        this.$nextTick(function() {
                            this.$emit('cambiarPaso', paso)
                        });
                    }
                }
            },
            seleccionarNuevoAsiento() {
                if (this.datos_compradores.asiento) {
                    this.datos_compradores.asiento = null;
                }

                this.$scrollTo('#mapa', 100);
            },
            AceptarVisibilidadReducida(){
                this.$modal.hide('visibilidad-reducida');
            }
        },
        components: {
            BuscarAbonadoComponent, SeleccionarZonaComponent, PasoDosComponent, PasoTresComponent, PasoCuatroComponent,
            VisibilidadReducida
        }
    }
</script>